
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gif-compressor",
      function () {
        return require("private-next-pages/gif-compressor/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gif-compressor"])
      });
    }
  